import { DiagnosticComponentVersionService_componentVersionServiceGetEntity } from '@festina/life-general-types/life/hooks/DiagnosticComponentVersionService_componentVersionServiceGetEntity'

export const useFetchComponentVersion =
  DiagnosticComponentVersionService_componentVersionServiceGetEntity.useQuery
